import type { CategoryAPI, SectionsEshopsComponent } from '@twisto/api-cms'

import type { EshopSelection } from './types'

const LEGACY_CATEGORY_IDS = {
  healthBeauty: 2,
  fashion: 8,
  homeDesign: 5,
}

const DEFAULT_CATEGORY_IDS = {
  CZ: [LEGACY_CATEGORY_IDS.healthBeauty, LEGACY_CATEGORY_IDS.fashion],
  PL: [
    LEGACY_CATEGORY_IDS.homeDesign,
    LEGACY_CATEGORY_IDS.healthBeauty,
    LEGACY_CATEGORY_IDS.fashion,
  ],
}

export const getSelectionKey = (selection: EshopSelection) =>
  selection.type === 'category'
    ? `category-${selection.category.id}`
    : selection.type

export const getEshopsNavigation = (
  categories: CategoryAPI[],
  region: string,
  navigation?: SectionsEshopsComponent['navigation'] | null
) => {
  const defaultIds =
    region === 'PL' ? DEFAULT_CATEGORY_IDS.PL : DEFAULT_CATEGORY_IDS.CZ
  const configuredItems = navigation
    ? navigation.items || []
    : [
        { type: 'all' as const },
        ...(region === 'CZ' ? [{ type: 'pay-in-3' as const }] : []),
        ...categories
          .filter((category) => defaultIds.includes(category.id))
          .map((category) => ({
            type: 'category' as const,
            categoryId: category.id,
          })),
      ]
  const items: EshopSelection[] = []
  const seen = new Set<string>()

  for (const item of configuredItems) {
    let selection: EshopSelection

    if (item.type === 'category') {
      const category = categories.find(({ id }) => id === item.categoryId)

      if (!category) {
        continue
      }

      selection = { type: 'category', category }
    } else if (item.type === 'all' || item.type === 'pay-in-3') {
      selection = { type: item.type }
    } else {
      continue
    }

    const key = getSelectionKey(selection)

    if (!seen.has(key)) {
      seen.add(key)
      items.push(selection)
    }
  }

  return {
    items,
    remainingCategories: categories.filter(
      (category) => !seen.has(`category-${category.id}`)
    ),
  }
}
